import { render, staticRenderFns } from "./AccountRegisterConfirm.vue?vue&type=template&id=4673349c"
import script from "./AccountRegisterConfirm.vue?vue&type=script&lang=js"
export * from "./AccountRegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports